module.exports = __webpack_public_path__ + "43223a9bb869c041addcc07d6a3414ae.png";